import { LocationStrategy } from '@angular/common'
import {
  Directive,
  ElementRef,
  HostListener,
  AfterViewInit,
  inject,
} from '@angular/core'
import { Router } from '@angular/router'

import { FrameDetectionService } from '../services'
import { UrlSynchronizationService } from '../services/url-synchronization.service'

@Directive({
  selector: '[routerLink]',
  standalone: false,
})
export class IframeAwareRouterLinkDirective implements AfterViewInit {
  private host = inject<ElementRef<HTMLElement>>(ElementRef)
  private frameDetection = inject(FrameDetectionService)
  private urlSync = inject(UrlSynchronizationService)

  ngAfterViewInit() {
    setTimeout(() => this.updateHref(), 0)
    setTimeout(() => this.updateHref(), 1000) // Retry for late targetUrl
  }

  private updateHref() {
    // Find anchor - could be the host itself or a child
    let anchor: HTMLAnchorElement | null = null

    if (this.host.nativeElement.tagName === 'A') {
      anchor = this.host.nativeElement as HTMLAnchorElement
    } else {
      anchor = this.host.nativeElement.querySelector('a')
    }

    if (!anchor || !anchor.href) return

    const currentHref = anchor.getAttribute('href')
    if (!currentHref || currentHref.startsWith('http')) return // Skip external/already modified links

    const path = currentHref // Use the href that routerLink already generated
    const huntBasePath = '/hunt' // Base path from verity hunt mode

    // Update href to point to target URL when in iframe

    if (this.frameDetection.isIframe() && this.urlSync.targetUrl) {
      const newHref =
        this.urlSync.targetUrl.replace(/\/$/, '') + huntBasePath + path
      anchor.href = newHref
    } else if (
      this.frameDetection.isIframe() &&
      this.urlSync.allowedOrigins.length > 0
    ) {
      // Fallback to first allowed origin
      const fallbackTarget = this.urlSync.allowedOrigins[0]
      const newHref = fallbackTarget.replace(/\/$/, '') + huntBasePath + path
      anchor.href = newHref
    }
  }

  @HostListener('click', ['$event'])
  onClick(evt: MouseEvent) {
    // Only intercept regular left-clicks (not modified clicks or right-clicks)
    if (
      evt.button !== 0 ||
      evt.metaKey ||
      evt.ctrlKey ||
      evt.shiftKey ||
      evt.altKey
    ) {
      return
    }
    // Let Angular's routerLink handle the navigation. We're just modifying the href for right-click scenarios
  }
}
